import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const PerformingArtist = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="85" viewBox="0 0 100 85" width="100" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path className={strokeStyle} d="M78.3 57.51s-.08.06-.15.07q.03-.05.01-.06h.13Z" fill={shades.black} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m86.58 51.88.06.02s-.02.06-.05.09a8.8 8.8 0 0 1-8.3 5.53h-.14s.03.04-.01.06a23.5 23.5 0 0 1-16.98.26.5.5 0 0 1-.23.18l-4.1 1.88-34.42 18.72c-2.16 1.4-6.48-1.46-9.63-6.4-3.2-4.93-4.06-10.03-1.91-11.4l31.22-23.79 3.36-2.94q.14-.12.3-.16a23.3 23.3 0 0 1 7.12-15.33c1.67-3.43 4.88-5.27 8.72-5.34.04-.03.04 0 .04 0l.08-.06a23.7 23.7 0 0 1 27.5 9.6 23.6 23.6 0 0 1-2.6 28.98c-.08.08-.18.23-.29.28l.28-.18z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M78.3 57.51s-.08.06-.15.07q.03-.05.01-.06h.13Z" fill={shades.black} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M74.66 50.83h.14q-.03.03-.15.05A23.65 23.65 0 0 1 49.4 11.91c6.47 3.15 12.8 8.74 17.67 16.26 4.83 7.46 7.36 15.5 7.61 22.67Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M85.7 16.1a23.6 23.6 0 0 1-2.59 29c-.28-7.16-2.78-15.08-7.55-22.44-4.78-7.4-11-12.96-17.41-16.09l.06-.04a23.7 23.7 0 0 1 27.5 9.57Z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M67.05 28.16c4.83 7.47 7.36 15.5 7.61 22.67v.05A23.65 23.65 0 0 1 49.4 11.91c6.46 3.15 12.79 8.74 17.66 16.26Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M83.11 45.1q-.12.15-.28.26l.26-.16h.05s0 .06-.04.08a8.8 8.8 0 0 1-8.3 5.56h-.15c-.24-7.17-2.78-15.2-7.6-22.67-4.87-7.52-11.2-13.11-17.67-16.25 1.64-3.47 4.86-5.28 8.7-5.36l.06.01c6.41 3.13 12.63 8.7 17.42 16.1 4.76 7.36 7.27 15.28 7.55 22.42Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M67.05 28.16c4.83 7.47 7.36 15.5 7.61 22.67h.14q-.03.03-.15.05A23.65 23.65 0 0 1 49.4 11.91c6.47 3.15 12.8 8.74 17.67 16.26Z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M17.04 60.52c3.17 4.91 4.01 10.03 1.88 11.41-2.14 1.38-6.46-1.48-9.63-6.38-3.2-4.95-4.04-10.06-1.9-11.44 2.13-1.38 6.45 1.48 9.65 6.42Z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M59.13 47.96a3.3 3.3 0 0 1-1.68 3.36l-4.09 1.9-34.45 18.71c2.13-1.38 1.3-6.49-1.88-11.4-3.2-4.95-7.52-7.81-9.65-6.43L38.6 30.33l3.37-2.92a3.25 3.25 0 0 1 3.75-.17 29.8 29.8 0 0 1 13.4 20.73z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path d="m40.12 38.32 6.67 10.31-5.16 3.35-3.33-5.16-5.17 3.34 3.34 5.15-5.16 3.34-6.68-10.32z" fill={shades.black} />
    </svg>
  );
};
